import React, { ReactNode } from "react";

import styles from "./TwoColumnPageLayout.module.scss";

interface Props {
  LeftColumn: ReactNode;
  RightColumn: ReactNode;
}

export const TwoColumnPageLayout = ({ LeftColumn, RightColumn }: Props) => (
  <>
    <section className={styles.twoColumnPageLayout__wrapper}>
      {LeftColumn} {RightColumn}
    </section>
  </>
);
